import { render, staticRenderFns } from "./AppsSkeleton.vue?vue&type=template&id=657a3990"
var script = {}
import style0 from "./AppsSkeleton.vue?vue&type=style&index=0&id=657a3990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports